/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'
import type {
    DeleteRequestDigitalLegacyParams,
    DigitalLegacyInfoDTO,
    GetRequestDigitalLegacyParams,
    HTTPValidationErrorDTO,
    PostRequestDigitalLegacyBodies,
    PostRequestDigitalLegacyParams,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Get digital legacy_data
 * @summary Save Digital Legacy
 */
export const postRequestDigitalLegacy = (
    postRequestDigitalLegacyBodies: BodyType<PostRequestDigitalLegacyBodies>,
    params: PostRequestDigitalLegacyParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/digital_legacy`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestDigitalLegacyBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestDigitalLegacyMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestDigitalLegacy>>,
        TError,
        { data: BodyType<PostRequestDigitalLegacyBodies>; params: PostRequestDigitalLegacyParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestDigitalLegacy>>,
    TError,
    { data: BodyType<PostRequestDigitalLegacyBodies>; params: PostRequestDigitalLegacyParams },
    TContext
> => {
    const mutationKey = ['postRequestDigitalLegacy']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestDigitalLegacy>>,
        { data: BodyType<PostRequestDigitalLegacyBodies>; params: PostRequestDigitalLegacyParams }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestDigitalLegacy(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestDigitalLegacyMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestDigitalLegacy>>
>
export type PostRequestDigitalLegacyMutationBody = BodyType<PostRequestDigitalLegacyBodies>
export type PostRequestDigitalLegacyMutationError = ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Save Digital Legacy
 */
export const usePostRequestDigitalLegacy = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestDigitalLegacy>>,
            TError,
            {
                data: BodyType<PostRequestDigitalLegacyBodies>
                params: PostRequestDigitalLegacyParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestDigitalLegacy>>,
    TError,
    { data: BodyType<PostRequestDigitalLegacyBodies>; params: PostRequestDigitalLegacyParams },
    TContext
> => {
    const mutationOptions = getPostRequestDigitalLegacyMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Delete Digital Legacy
 */
export const deleteRequestDigitalLegacy = (
    params: DeleteRequestDigitalLegacyParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>({ url: `/digital_legacy`, method: 'DELETE', params }, options)
}

export const getDeleteRequestDigitalLegacyMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestDigitalLegacy>>,
        TError,
        { params: DeleteRequestDigitalLegacyParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestDigitalLegacy>>,
    TError,
    { params: DeleteRequestDigitalLegacyParams },
    TContext
> => {
    const mutationKey = ['deleteRequestDigitalLegacy']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestDigitalLegacy>>,
        { params: DeleteRequestDigitalLegacyParams }
    > = (props) => {
        const { params } = props ?? {}

        return deleteRequestDigitalLegacy(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestDigitalLegacyMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestDigitalLegacy>>
>

export type DeleteRequestDigitalLegacyMutationError = ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Delete Digital Legacy
 */
export const useDeleteRequestDigitalLegacy = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestDigitalLegacy>>,
            TError,
            { params: DeleteRequestDigitalLegacyParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestDigitalLegacy>>,
    TError,
    { params: DeleteRequestDigitalLegacyParams },
    TContext
> => {
    const mutationOptions = getDeleteRequestDigitalLegacyMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get digital legacy_data
 * @summary Get Digital Legacy
 */
export const getRequestDigitalLegacy = (
    params: GetRequestDigitalLegacyParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DigitalLegacyInfoDTO>(
        { url: `/digital_legacy`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestDigitalLegacyQueryKey = (params?: GetRequestDigitalLegacyParams) => {
    return [`/digital_legacy`, ...(params ? [params] : [])] as const
}

export const getGetRequestDigitalLegacyQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDigitalLegacyParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDigitalLegacy>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestDigitalLegacyQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestDigitalLegacy>>> = ({
        signal,
    }) => getRequestDigitalLegacy(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestDigitalLegacyQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestDigitalLegacy>>
>
export type GetRequestDigitalLegacyQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestDigitalLegacy<
    TData = Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDigitalLegacyParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDigitalLegacy>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestDigitalLegacy>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestDigitalLegacy<
    TData = Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDigitalLegacyParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDigitalLegacy>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestDigitalLegacy>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestDigitalLegacy<
    TData = Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDigitalLegacyParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDigitalLegacy>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Digital Legacy
 */

export function useGetRequestDigitalLegacy<
    TData = Awaited<ReturnType<typeof getRequestDigitalLegacy>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDigitalLegacyParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDigitalLegacy>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestDigitalLegacyQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}
